module.exports = "<div class=\"vcm_resources_images\">\r\n    <iframe class=\"vcm_iframe\" [src]=\"url | vcmSanitizeUrl\"></iframe>\r\n</div>";